import React from 'react'
import { Link, usePage } from '@inertiajs/react'
import { 
  Users, 
  Building2, 
  MapPin, 
  Layers, 
  BarChart3,
  Home,
  ChevronLeft,
  Tag
} from 'lucide-react'
import { ToastManager } from './Toast'
import Navbar from './Navbar'

interface AdminLayoutProps {
  children: React.ReactNode
}

export default function AdminLayout({ children }: AdminLayoutProps) {
  const page = usePage()
  const url = page.url
  const flash = page.props.flash

  const navigation = [
    { name: 'Dashboard', href: '/admin', icon: Home },
    { name: 'Users', href: '/users', icon: Users },
    { name: 'Countries', href: '/countries', icon: MapPin },
    { name: 'Providers', href: '/providers', icon: Building2 },
    { name: 'Clients', href: '/clients', icon: Building2 },
    { name: 'Verticals', href: '/verticals', icon: Layers },
    { name: 'Tags', href: '/tags', icon: Tag },
  ]

  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-gray-50">
        <ToastManager flash={flash || {}} />
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex gap-8">
          {/* Sidebar Navigation */}
          <div className="w-48 flex-shrink-0">
            <nav className="space-y-1">
              {navigation.map((item) => {
                const isActive = url === item.href || (item.href !== '/admin' && url.startsWith(item.href))
                return (
                  <Link
                    key={item.name}
                    href={item.href}
                    className={`${
                      isActive
                        ? 'bg-blue-50 border-blue-500 text-blue-700'
                        : 'border-transparent text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                    } group flex items-center px-3 py-2 text-sm font-medium border-l-4 transition-colors`}
                  >
                    <item.icon
                      className={`${
                        isActive ? 'text-blue-500' : 'text-gray-400 group-hover:text-gray-500'
                      } flex-shrink-0 -ml-1 mr-3 h-5 w-5`}
                    />
                    <span className="truncate">{item.name}</span>
                  </Link>
                )
              })}
            </nav>
          </div>

          {/* Main content */}
          <div className="flex-1 min-w-0">
            {children}
          </div>
        </div>
      </div>
      </div>
    </>
  )
}